module.exports = __webpack_public_path__ + "img/Android Store.a5cbe065.svg";